import React, {Fragment} from "react";
import Button from "../Button";
import {default as VoucherPaymentList} from "../../editors/OperationList/Elements/VoucherPayment";
import BigNumber from "bignumber.js";
import debounce from "../../../utils/debounce";
import {isEqual} from "lodash-es";
import {get, set} from "../../../utils/dotutils";

export default class VoucherPayment extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.option || {}
        }
        this.saveChanges = debounce((name, v) => {
            this.props.setFieldValue && this.props.setFieldValue(name, v);
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.option, prevProps.option)) {
            this.setState({
                value: this.props.option
            })
        }
    }

    setFieldValue = (field, value) => {
        return new Promise((resolve) => {
            let oldValue = get(this.state.value, field);
            if (!isEqual(oldValue, value)) {
                const v = {...this.state.value};
                set(v, field, value);
                this.setState({
                    value: v,
                }, () => resolve());
                this.saveChanges(String(this.props.optionIndex), v);
            }
        });
    }

    render() {
        const vouchers = this.props.option?.vouchers || [];
        return (
            <div className="payment voucher-payment">
                <Button
                    color="default"
                    block={true}
                    onClick={() => {
                        this.voucher && this.voucher.focus();
                    }}>
                        {
                            vouchers.length ?
                            <Fragment>
                                {vouchers.length} Utalvány ({vouchers.length ? vouchers.map((voucher) => parseFloat(voucher.amount || voucher.saleprice)).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0")) : 0} Ft)
                            </Fragment> :
                            <Fragment>
                                Kiválasztás
                            </Fragment>
                        }
                    </Button>
                <VoucherPaymentList
                    ref={(cpi) => this.voucher = cpi}
                    selection={vouchers}
                    setSelected={async (vouchers) => {
                        let voucherAmount = vouchers.reduce((sum, voucher) => sum.plus(voucher.amount || voucher.saleprice || 0), new BigNumber(0)).toNumber();

                        await this.setFieldValue("vouchers", vouchers);
                        await this.setFieldValue("amount", voucherAmount);
                    }}
                />
            </div>
        );
    }
}